export class VariableState {
    constructor(variableName, state) {
        this.variableName = variableName;
        this.state = state;
    }
}
